import { I18n } from 'aws-amplify'

const Strings = () => ({
  notFoundPageTxt: I18n.get('Sorry, we couldnt find what you were looking for!')
})

export default Strings
